import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  printLabelText: {
    description: 'Action description to print a return request label',
    defaultMessage: 'Print Label',
    id: 'H8oauE',
  },
  sendReturnLabelText: {
    description: 'Action description to send a return request label',
    defaultMessage: 'Send Return Label',
    id: 'bcz8lq',
  },
  cancelSuccessTitle: {
    description: 'Content for a success message after cancelling a return request',
    defaultMessage: 'Return request has been cancelled.',
    id: 'wIvi14',
  },
  cancelRequestText: {
    description: 'Action description to cancel a return request',
    defaultMessage: '{hasLabel, select, true {Void Label and} other {}} Cancel Return',
    id: 'DNjO1a',
  },
  viewOnMarketplaceText: {
    description: 'Action description to view a return request on the marketplace',
    defaultMessage: 'View on {marketplaceName}',
    id: 'azPjp9',
  },
  sendLabelSuccessTitle: {
    description: 'Title for a success message after sending a label',
    defaultMessage: 'Return label sent!',
    id: 'OGbR89',
  },
  sendLabelSuccessContent: {
    description: 'Content for a success message after sending a label',
    defaultMessage: 'The return label has been sent to {count, plural, one {# recipient} other {# recipients}} successfully.',
    id: '474gTb',
  },
  sendReturnLabelModalDescription: {
    description: 'Description text for the send return label modal',
    defaultMessage:
      'You can send the shipping label to your customers. Enter the recipient email address (for multiple emails, separate with a comma or press enter).',
    id: 'SxHRzZ',
  },
  errorTitle: {
    description: 'Title for an error message',
    defaultMessage: 'Error',
    id: '0kLO2P',
  },
  errorContent: {
    description: 'Content for an error message',
    defaultMessage: 'Please try again.',
    id: 'JOOJke',
  },
  returnActionsText: {
    defaultMessage: 'Return Actions',
    id: 'orh69B',
    description: 'title for a drop down menu that contains actions that can be performed on a return',
  },
});
